var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPlusWhite = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Plus")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/lined/plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,25 L25,38.6666667 C25,39.2189514 24.5522847,39.6666667 24,39.6666667 C23.4477153,39.6666667 23,39.2189514 23,38.6666667 L23,25 L9.3333333,25 C8.78104855,25 8.3333333,24.5522847 8.3333333,24 C8.3333333,23.4477153 8.78104855,23 9.3333333,23 L23,23 L23,9.3333333 C23,8.78104855 23.4477153,8.3333333 24,8.3333333 C24.5522847,8.3333333 25,8.78104855 25,9.3333333 L25,23 L38.6666667,23 C39.2189514,23 39.6666667,23.4477153 39.6666667,24 C39.6666667,24.5522847 39.2189514,25 38.6666667,25 L25,25 Z",
    id: "Path",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-white.9a4e2698.svg";
export { ForwardRef as ReactComponent };